import * as Yup from "yup";
import { validateAddress } from "../../../utils/address";

export default (t: any) => {
  return Yup.object().shape({
    name: Yup.string()
      .typeError(t("Nameisrequired"))
      .required(t("Nameisrequired"))
      .min(2, t("Namemustbeatleast2chars"))
      .max(100, t("Namemustnotexceed100chars")),

    tagLine: Yup.string()
      .min(5, t("Taglineshouldbeatleast5characterslong"))
      .max(255, t("Taglineshouldnotexceed255characters")),

    // phone: Yup.string()
    //   .typeError(t("Phonenumberisrequired"))
    //   .required(t("Phonenumberisrequired"))
    //   .min(10, t("PhoneNumbermustbe10characterslong"))
    //   .max(15, t("PhoneNumbermustbe10characterslong")),

    // email: Yup.string().email(t("Pleaseprovideavalidemailaddress")),

    userName: Yup.string()
      .typeError(t("Nameisrequired"))
      .required(t("Nameisrequired"))
      .min(2, t("Namemustbeatleast2chars"))
      .max(100, t("Namemustnotexceed100chars")),

    userLoginUserName: Yup.string()
      .typeError(t("UserNameisrequired"))
      .required(t("UserNameisrequired"))
      .min(4, t("UserNamemustbeatleast4chars"))
      .max(50, t("UserNamemustnotexceed50chars"))
      .test(
        "withNoSpace",
        t("UserNameShouldNotContainSpace"),
        function (value) {
          return value.search(" ") < 0;
        }
      ),

    userPassword: Yup.string()
      .typeError(t("Passwordisrequired"))
      .required(t("Passwordisrequired"))
      .min(8, t("Passwordmustbeatleast8chars"))
      .max(50, t("Passwordmustnotexceed50chars")),

    userConfirmPassword: Yup.string()
      .typeError(t("ConfirmPasswordisrequired"))
      .required(t("ConfirmPasswordisrequired"))
      .min(8, t("Passwordmustbeatleast8chars"))
      .max(50, t("Passwordmustbeatleast8chars")),

    userPhone: Yup.string()
      .typeError(t("Phonenumberisrequired"))
      .required(t("Phonenumberisrequired"))
      .min(10, t("PhoneNumbermustbe10characterslong"))
      .max(15, t("PhoneNumbermustbe10characterslong")),

    userEmail: Yup.string()
      .typeError(t("Emailisrequired"))
      .required(t("Emailisrequired"))
      .email(t("Pleaseprovideavalidemailaddress")),

    branchName: Yup.string()
      .typeError(t("BranchNameisrequired"))
      .required(t("BranchNameisrequired"))
      .min(2, t("BranchNamemustbeatleast2chars"))
      .max(100, t("BranchNamemustnotexceed100chars")),

    // branchPhone: Yup.string()
    //   .typeError(t("BranchPhonenumberisrequired"))
    //   .required(t("BranchPhonenumberisrequired"))
    //   .min(10, t("BranchPhoneNumbermustbe10characterslong"))
    //   .max(15, t("BranchPhoneNumbermustbe10characterslong")),

    // branchEmail: Yup.string().email(t("Pleaseprovideavalidemailaddress")),

    // branchAddress: Yup.string()
    //   .min(5, t("Addressshouldbeatleast5characterslong"))
    //   .max(255, t("Addressshouldnotexceed255characters")),

    // branchAddress: Yup.string()
    //   .typeError(t("Addressisrequired"))
    //   .required(t("Addressisrequired"))
    //   .test("valid-address", t("Addressisrequired"), function (value) {
    //     try {
    //       const address = JSON.parse(value);
    //       if (
    //         !address ||
    //         !address.address1 ||
    //         address.address1.length < 1 ||
    //         !address.city ||
    //         address.city.length < 1 ||
    //         !address.pincode ||
    //         address.pincode.length < 5 ||
    //         !address.state ||
    //         address.state.length < 1
    //       ) {
    //         return false;
    //       } else {
    //         return true;
    //       }
    //     } catch (ex) {
    //       return false;
    //     }
    //   }),

    branchAddress: Yup.string()
      .typeError("REQUIRED")
      .required("REQUIRED")
      .test("valid-address", "REQUIRED", validateAddress)
      .max(255, t("MAX_ADDRESS_LENGTH")),

    currency: Yup.string()
      .typeError(t("currencyisrequired"))
      .required(t("currencyisrequired")),

    workingHoursPerDay: Yup.number().required(
      t("WorkingHoursPerDayisrequired")
    ),

    workingDaysPerWeek: Yup.number().required(
      t("WorkingDaysPerWeekisrequired")
    ),

    // branchUserName: Yup.string()
    //   .typeError(t("Nameisrequired"))
    //   .required(t("Nameisrequired"))
    //   .min(2, t("Namemustbeatleast2chars"))
    //   .max(100, t("Namemustnotexceed100chars")),

    // branchUserLoginUserName: Yup.string()
    //   .typeError(t("UserNameisrequired"))
    //   .required(t("UserNameisrequired"))
    //   .min(4, t("UserNamemustbeatleast4chars"))
    //   .max(50, t("UserNamemustnotexceed50chars")),

    // branchUserPassword: Yup.string()
    //   .typeError(t("Passwordisrequired"))
    //   .required(t("Passwordisrequired"))
    //   .min(8, t("Passwordmustbeatleast8chars"))
    //   .max(50, t("Passwordmustnotexceed50chars")),

    // branchUserPhone: Yup.string()
    //   .typeError(t("Phonenumberisrequired"))
    //   .required(t("Phonenumberisrequired"))
    //   .min(10, t("PhoneNumbermustbe10characterslong"))
    //   .max(15, t("PhoneNumbermustbe10characterslong")),

    // branchUserEmail: Yup.string().email(t("Pleaseprovideavalidemailaddress")),

    // branchUserAddress: Yup.string()
    //   .min(5, t("Addressshouldbeatleast5characterslong"))
    //   .max(255, t("Addressshouldnotexceed255characters")),

    // branchUserPaymentRate: Yup.string().concat(isNonNegative(t("PaymentRatecannotbenegative"))),

    // branchUserPaymentTerm: Yup.mixed().oneOf(
    //   ["hour", "day", "week", "month"],
    //   t("ValidPaymentTermsare")
    // ),
  });
};
